import { Theme } from '@material-ui/core';

export const getScrollbarStyles = (theme: Theme) => ({
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
    position: 'absolute',
    top: 0,
    right: 0,
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '2px',
    background: theme.palette.primary.main,
  },
  '&::-webkit-scrollbar-track': {
    borderRadius: '2px',
    background: 'rgba(0, 0, 0, 0.05)',
  },
});
